import apollo from 'graphql/apollo';
import { createInputFieldMutation } from 'graphql/mutations';
import { grabFirstGQLDataResult } from 'utils/helpers';

const createInputField = async ({ categoryId, parentId, parentType, categoryListQuery, ...props }) =>
  apollo.mutate({
    mutation: createInputFieldMutation,
    variables: { categoryId, parentId, parentType, inputField: props },
    refetchQueries: ['ItemCatalogueConfiguration'],
    update: (cache, { data }) => {
      try {
        const result = grabFirstGQLDataResult(data);
        const cachedData = cache.readQuery({ query: categoryListQuery });
        cache.writeQuery({
          query: categoryListQuery,
          data: {
            categories: cachedData.categories.map((c) =>
              c._id === categoryId ? { ...c, inputFields: [...(c.inputFields || []), result] } : c,
            ),
          },
        });
      } catch (e) {
        console.log(e);
      }
    },
  });
export default createInputField;
